<template>
    <div class="page-wrapper">
        <div class="select-tip-box select-tip-fixed" v-if="selectionState == 'y' && fixedSelectTipShow">
            <i class="icon el-icon-warning"></i>
            <span class="text" v-if="selectionNumber == 0">请选择商品</span>
            <span class="text" v-else>已选择 {{selectionNumber}} 款商品</span>
        </div>
        <div class="page-wrapper-scroll" @scroll="scrollHandle">
            <div class="titleLine">
                <div class="left">选品中心</div>
                <div class="right"><button class="cg-btn mgl-16" @click="exportMallList">下载表格</button></div>
            </div>
            <div class="header-handle">
                <div class="search-box">
                    <el-input
                        size="mini"
                        placeholder="ID/商品名称/款号/品牌"
                        prefix-icon="el-icon-search"
                        v-model.trim="searchWords"
                        clearable
                        >
                    </el-input>
                    <button class="cg-btn red" @click="searchHandle">搜索</button>
                </div>
                <div class="btns">
                    <button class="cg-btn red" @click="selectHandle">批量选择</button>
                </div>
            </div>
            <div class="select-tip-box" v-if="selectionState == 'y'">
                <i class="icon el-icon-warning"></i>
                <span class="text" v-if="selectionNumber == 0">请选择商品</span>
                <span class="text" v-else>已选择 {{selectionNumber}} 款商品</span>
            </div>
            <div class="table-wrap clearfix" ref="mallList">
                <div class="oneGoodList" v-for="list in tableData" :key="list.item_id">
                    <div class="inner" :class="{'select-state': selectionState == 'y', 'checked': list.checked}"
                        @click="checkHandle(list)"
                    >
                        <div class="imgBox" @click="toGoodsDetail(list)">
                            <el-image class="img"  :src="list.mallItemFileUrl"  :fit="fit"></el-image>
                        </div>
                        <div class="content">
                            <div class="nameLine">
                                <div class="goodTitle intwoline" @click="toGoodsDetail(list)">{{list.itemName}}</div>
                                <div class="brand">{{list.brandName}} </div>
                            </div>
                            
                            <div class="price">￥{{list.price |price}}</div>
                            <div class="bottomLine">
                                <div class="left">款号：{{list.styleNumber}}</div>
                                <!-- <div class="left">款号：{{list.styleNumber}}</div> -->
                                <div class="left">库存：{{list.stock}}件</div>
                            </div>
                        </div>
                        <div class="goods-checkbox-wrap" @click.stop>
                            <el-checkbox class="goods-checkbox" v-model="list.checked" @change="checkChange(list)" v-if="selectionState == 'y'"></el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="cg-pagination-wrap">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 50, 60,100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <div class="bottom-handlebar-blank" v-if="selectionState == 'y'"></div>
        </div>
        <div class="bottom-handlebar" v-if="selectionState == 'y'">
            <button class="cg-btn" @click="cancelSelectHandle">取消</button>
            <button class="cg-btn red mgl-16" @click="submitSelection">确认上架云仓商城</button>
        </div>
    </div>
</template>

<script>
import { mallItemList, exportMallList } from '../../../api/dealer'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import moment from 'moment'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            fit:'cover',
            tableData: [],
            // 分页
            pageSize: 60,
            total: 0,
            currentPage: 1,

            selectionState: 'n', // y - 批量选择  n - 不选择
            selectionArray: [],  // 已选商品

            fixedSelectTipShow: false,
            selectTipOffsetTop: 0
        }
    },
    computed: {
        ...mapGetters(['userId']),
        selectionNumber: function() {
            return this.selectionArray.length
        },
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 60
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.mallItemList();
            },
            immediate: true
        }
    },
    mounted() {
        this.selectTipOffsetTop = this.$refs.mallList.offsetTop
    },
   
    methods: {
        selectHandle() {
            this.selectionState = 'y'
        },
        checkHandle(list) {
            list.checked = !list.checked
            this.manageSelectionArray(list)
        },
        checkChange(list) {
            console.log(list)
            this.manageSelectionArray(list) 
        },
        manageSelectionArray(list) {
            if (list.checked) {
                this.selectionArray.push(list)
            } else {
                let checkdIndex = -1;
                this.selectionArray.some((item,index) => {
                    if(item.item_id == list.item_id) {
                        checkdIndex = index
                    }
                })
                if (checkdIndex >=0) {
                    this.selectionArray.splice(checkdIndex, 1)
                }
            }
            // console.log(this.selectionArray)
        },
        cancelSelectHandle() {
            this.selectionState = 'n'
            this.fixedSelectTipShow = false
            this.selectionArray = []
            this.tableData.forEach(item => {
                item.checked = false
            })
        },
        scrollHandle(e) {
            // console.log(e.target.scrollTop)
            if (this.selectionState == 'n') return
            if (e.target.scrollTop > this.selectTipOffsetTop) {
                this.fixedSelectTipShow = true
            } else {
                this.fixedSelectTipShow = false
            }
        },
        submitSelection() {
            if (this.selectionNumber == 0) {
                this.$message.error('请选择商品');
                return
            }
            this.$confirm('确认将选中的商品上架云仓商城吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                this.cancelSelectHandle();
                this.handleCurrentChange(1);
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
            })
        },


        exportMallList() {
            exportMallList({
                user_id: '',
                user_token: '',
                image_type: 12104,  // 12104 - 缩略图   12101 - 原图
                item_state: 1,

            }).then(res => {
                console.log(res)
                if (res.error_code == 0) {
                    this.$message.success('成功获取下载链接！')
                    saveAs(res.data.file, `zciiss数字云仓_商城商品_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                    // window.location.href=res.data.file;
                } else {
                    this.$message.error(res.error_msg || '下载失败！')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        mallItemList() {
            this.loading = true
            mallItemList({
                fuzzyQuery: this.searchWords,
                page: this.currentPage,
                num: this.pageSize,
                defaultValue: '1'  // defaultValue 这个字段是为了与 衣加加APP中的云仓商品列表作区分
                // userId: this.userId
            }).then(res => {
                this.loading = false
                console.log('mallItemList-res', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.mallItemList.map(item => {
                        return {
                            ...item,
                            mallItemFileUrl: process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl,
                            checked: this.selectionArray.some(e => e.item_id == item.item_id)
                        }
                    })
                    this.total = parseInt(res.data.totalCount)

                     // itemName: "时尚前卫连衣裙"
                // itemState: 1
                // itemUnqueNumber: 167225723224
                // item_id: "2926"
                // mallItemFileUrl: "/static/digitalWarehouse/12101/2020/04/22/59f3fa82ee7308a1ae868d6b78ab6fb6.jpg"
                // stock: 44
                // styleNumber: "sd34325545"
                // user_id: "5403"
                } else if (res.errorCode == -10111) {
                    // 暂无商品列表
                    this.tableData = []
                    this.total = 0
                    this.$message.error(res.errorMsg || '暂无商品列表')
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log('mallItemList-err', err)
            })
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },
        // toGoodsEdit(row) {
        //     console.log(row);
        //     this.$router.push('/supplier/goods/edit?id=' + row.item_id)
        // },
        toGoodsDetail(row) {
            if (this.selectionState == 'n') {
                this.$router.push('/supplier/selection-mall/detail?id=' + row.item_id)
            }
        },
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            console.log(val)
            console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/supplier/selection-mall/list?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            console.log(val)
            console.log(`当前页: ${val}`);
            this.currentPage = val
            this.curRoutePush()
        }
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    padding: 0;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    .page-wrapper-scroll {
        padding: 24px;
        height: 100%;
        overflow-y: auto;
        overflow-x: visible;
        box-sizing: border-box;
    }
}
.header-handle {
    margin-top: 24px;
    margin-bottom: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.select-tip-box {
    height: 40px;
    background: #FFFBE6;
    border-radius: 2px;
    border: 1px solid #FFE58F;
    line-height: 40px;
    padding-left: 16px;
    .icon {color: #FAAD14; font-size: 14px; margin-right: 6px;}
    .text {font-size: 14px; color: rgba(0, 0, 0, 0.65);}
}
.select-tip-fixed {
    position: absolute;
    top:0;
    right: 40px;
    left: 24px;
    z-index: 10;
}
.table-wrap {
    background: #fff;
    padding:20px 15px;
    min-width: 800px;
    box-sizing: content-box;
}

// 一个商品
.oneGoodList .imgBox:hover{cursor: pointer;}
.oneGoodList {
    float: left; width: 20%; box-sizing: border-box; padding: 16px 1%;
    .inner {
        min-width: 160px; position: relative;
        &:hover {box-shadow: 0 0 10px 0px #eee;}
    }
    .imgBox{
        background: #efefef;
        .img{display: block; width:100%; height:calc(100vw / 5); min-height: 170px;}
    }
    .content {
        height: 180px;
        box-sizing: border-box;
        padding: 16px;
    }
    .nameLine{
        .goodTitle{
            color:#2A2E3F;font-size: 16px;line-height: 20px; margin-bottom:0px; height: 40px; cursor: pointer;
        } 
       .brand{color:#666666;font-size: 12px;}
    }
    .price{color:#E11010;font-size: 24px; margin-top:16px;}
    .bottomLine{color:#666666;font-size: 12px; }
    .goods-checkbox-wrap {position: absolute; left: 8px; top: 8px;}

    .inner.select-state {
        cursor: pointer;
        &.checked {
            box-shadow: 0 0 0px 1px #F81D22;
            &:hover {box-shadow: 0 0 0px 1px #F81D22;}
        }
    }
}

.titleLine{display: flex;
    .left{flex:1;color:#333;font-size: 30px;font-weight: bold;}
    .right{flex:1;text-align: right;}
}
.bottom-handlebar-blank {height: 64px;}
.bottom-handlebar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    padding: 18px 40px 0 0;
    box-sizing: border-box;
    background: #fff;
    text-align: right;
    box-shadow: 0 -1px 8px #ccc;
}
</style>